import { GetterTree } from "vuex";
import { RootState } from "@/types";
import { CostState, IDailyCost } from "@/types/cost";
import { Cost } from "@/models/cost";
import { Pagination } from "@/models/pagination";
import moment from "moment";

export const getters: GetterTree<CostState, RootState> = {
  list: state => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: state => {
    return state.pagination || new Pagination();
  },
  single: state => {
    return state.cost || new Cost();
  },
  siteDailyCost: state => {
    if (!state.pagination) {
      return [];
    }
    const daily: IDailyCost[] = [];
    state.pagination.data.forEach(cost => {
      const date = moment(cost.accounted_at).format("YYYY-MM-DD");
      const condition = daily.find(data => {
        return data.date === date;
      });

      if (condition) {
        condition.costs.push(cost);
      } else {
        daily.push({
          date,
          costs: [cost]
        });
      }
    });
    return daily;
  },
  amount: state => state.amount,
  volume: state => state.volume
};
export default getters;
